import React, { FC, ChangeEvent } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import styles from '../../experience.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type IEtcExperienceDescProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
};

const maxLength = 300;

const EtcExperienceDesc: FC<IEtcExperienceDescProps> = ({ prefixName, ...props }) => {
  const name = `${prefixName}.description`;
  const { field } = useController({
    name,
    ...props,
  });

  const length = field.value?.length ?? 0;

  const placeholder =
    '본인의 경험에 대해 자유롭게 설명해주세요. \n\n' +
    "- '희망의 연탄 나르기'봉사활동 매주 참여 (2011년 ~) \n" +
    "- '전국 대학생 디자인 공모전' 참여 및 대상 수상 (2019.03)\n\n" +
    '[프로젝트]\n' +
    '- 2022.01 ~ 2022.04\n' +
    '- 담당 역할 : PO 및 프론트 개발\n' +
    '- 신규 커머스 플랫폼 개발 프로젝트 참여\n' +
    '- 플레이스토어에 판매 (누적 10,000건 다운로드, 만족도 4.2/5점)';

  //한글 입력시 maxLength 초과되는 이슈로 인해서 onChange 이벤트 추가
  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) {
      return;
    }

    field.onChange(e.target.value);
  };

  return (
    <div className={cx('activityWrap')}>
      <div className={cx('activityTitle')}>내용</div>

      <div className={cx('textareaWrap')}>
        <textarea {...field} placeholder={placeholder} maxLength={maxLength} rows={10} onChange={onChange} />
        <div className={cx('infoText')}>
          최대 글자수 : <span className={cx('value')}>{length}</span> / 300
        </div>
      </div>
    </div>
  );
};

export default EtcExperienceDesc;
